import { Card, Row, Col, Button, Badge } from "react-bootstrap";
import { FiChevronRight as Scopri } from 'react-icons/fi'
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getSondaggioColor } from "../../Utilities/getBorderColor";
import NumberFormat from "react-number-format"

/*
 <CartaSondaggio key={index} 
 sondaggio={sondaggio} 
 setActiveTab={props.setActiveTab} />

*/
export default function CartaSondaggio(props) {
    const navigate = useNavigate()

    return (
        <Card className="cartaSommario w-100 mt-4 mb-2"
            border={getSondaggioColor(props.sondaggio)}
        >
            <Card.Body>
                <h5><strong>{props.sondaggio.sonTitolo}</strong></h5>
                <Row className="w-100 m-0 mt-3 p-0">
                    <Col xs={6} md={3}>
                        <strong>Data inizio:</strong>
                        <>
                            <div style={{ margin: 0 }}>{dayjs(props.sondaggio.sonDataInizio).format("DD/MM/YYYY")}</div>
                            <span style={{ fontSize: "0.85em", color: "#666" }}>
                                {dayjs(props.sondaggio.sonDataInizio).format("HH:mm")}
                            </span>
                        </>

                        {/*sondaggio.sonDataInizio ? (
                                                    <>
                                                        {dayjs(sondaggio.sonDataInizio).format("DD/MM/YYYY")}<br />
                                                        <span style={{ fontSize: "0.85em", color: "#666" }}>
                                                            {dayjs(sondaggio.sonDataInizio).format("HH:mm")}
                                                        </span>
                                                    </>
                                                ) : "--"*/}
                    </Col>
                    <Col xs={6} md={3}>
                        <strong>Data chiusura:</strong>
                        <div style={{ margin: 0 }}>{dayjs(props.sondaggio.sonDataChiusura).format("DD/MM/YYYY")}</div>
                        <span style={{ fontSize: "0.85em", color: "#666" }}>
                            {dayjs(props.sondaggio.sonDataChiusura).format("HH:mm")}
                        </span>
                    </Col>
                    <Col xs={6} md={3}>
                        <strong>Categorie:</strong>
                        <p>
                            {props.sondaggio.sonCategorie.categorie.map((el, i) => (
                                <span key={i}>
                                    <span key={i}>{el}</span>
                                    {i !== props.sondaggio.sonCategorie.categorie.length - 1 &&
                                        <span>, </span>}
                                </span>

                            ))}
                        </p>
                    </Col>




                    <Col xs={6} md={3} className="d-flex align-self-center">
                        <Badge pill
                            bg={getSondaggioColor(props.sondaggio)}
                            className="mt-auto mx-md-auto py-2 "
                            style={{ fontWeight: '100', fontSize: '0.80em' }}>
                            {props.sondaggio.sonStato}
                        </Badge>
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer className='text-center px-0 pb-3'>
                <Row className='w-100 p-0 m-0 d-flex'>
                    <Col xs={12} md={9} className='pr-0'>
                        {/*TODO SONDAGGI: mettere la possibilità all'amministratore se visualizzare o meno il numero di risposte */}
                        {/*
                    
                    {
                                    props.numeroRisposte == 1?
                                    (
                                        <>
                                        <span >
                            <strong className="bigText">
                                
                               <NumberFormat
                                    displayType="text"
                                    thousandSeparator="." 
                                    decimalSeparator=","
                                    value={props.numeroRisposte} 
                                />
                            </strong>
                            {' '} risposta
                        </span>
                                        </>

                                    ):(
                                        <>
                                        <span >
                            <strong className="bigText">
                                
                               <NumberFormat
                                    displayType="text"
                                    thousandSeparator="." 
                                    decimalSeparator=","
                                    value={props.numeroRisposte} 
                                />
                            </strong>
                            {' '} risposte
                        </span>
                                        </>
                                    )
                                }
                        

                   
*/}
                    </Col>
                    <Col xs={12} md={3} className="p-0 d-flex align-items-baseline">
                        <Button variant="outline-primary" size="sm" className="mt-auto mx-auto"
                            onClick={() => {
                                props.setActiveTab("informazioni")
                                navigate('/sondaggio', { state: { sonId: props.sondaggio.sonId } })
                            }}>
                            Scopri
                            < Scopri />
                        </Button>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    )
}